/**
 * Create SVG nodes from raw SVG markup.
 * onefold's html`` uses document.createElement which doesn't work for SVG elements
 * (they need createElementNS with the SVG namespace). This helper parses SVG strings
 * into real SVG DOM nodes using innerHTML on a temporary container.
 */
export function svgNode(svgMarkup: string): Node {
  const container = document.createElement('div');
  container.innerHTML = svgMarkup;
  return container.firstElementChild ?? document.createComment('svg-empty');
}

// Pre-built icons
export const BurgerIcon = (): Node => svgNode(
  `<svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <rect y="3" width="20" height="2" rx="1"/>
    <rect y="9" width="20" height="2" rx="1"/>
    <rect y="15" width="20" height="2" rx="1"/>
  </svg>`
);

export const SearchIcon = (): Node => svgNode(
  `<svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85zm-5.242.156a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9z"/>
  </svg>`
);

export const OnefoldLogo = (): Node => svgNode(
  `<svg width="32" height="32" viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg">
    <polygon points="83.8,39.8 108,64 64,108 20,64 44.2,39.8" fill="#4338CA"/>
    <polygon points="83.8,39.8 44.2,39.8 64,59.6" fill="#818CF8"/>
  </svg>`
);

export const PlayIcon = (): Node => svgNode(
  `<svg width="10" height="10" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 2l10 6-10 6V2z"/>
  </svg>`
);

export const ExpandIcon = (): Node => svgNode(
  `<svg width="12" height="12" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1h5v2H3.414L6.707 6.293l-1.414 1.414L2 4.414V7H0V1h1zm14 0h-5v2h2.586L9.293 6.293l1.414 1.414L14 4.414V7h2V1h-1zM1 15h5v-2H3.414l3.293-3.293-1.414-1.414L2 11.586V9H0v6h1zm14 0h-5v-2h2.586l-3.293-3.293 1.414-1.414L14 11.586V9h2v6h-1z"/>
  </svg>`
);

export const ShrinkIcon = (): Node => svgNode(
  `<svg width="12" height="12" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 1v4H1v2h5a1 1 0 001-1V1H5zm6 0v5a1 1 0 001 1h5V5h-4V1h-2zM1 9v2h4v4h2v-5a1 1 0 00-1-1H1zm9 0a1 1 0 00-1 1v5h2v-4h4V9h-5z"/>
  </svg>`
);
